export class ImpuestosReteidos {
    BASE:number;
    TAX_TYPE:string;
    BILL_TAX_ID:number;
    TAX_VALUE:number;
    AMOUNT:number;
    index:number;
    BILL_TAX_IDValue: string;
    TAX_TYPEValue:string;
    BILL_DETAIL_TAX_ID:number;
    BILL_DETAIL_ID:number;
    BILL_TAX_KEY:string;
}


// WEBPACK FOOTER //
// ./src/app/models/impuestosRetenidos.ts